/**
################################
 * Component event_carousel
 * Built with Maciste / Version 2.0
################################
*/

import 'slick-carousel';

'use strict';

jQuery(document).ready(function ($) {
    $('.event_carousel_init').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,

        responsive: [

            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });
});

